import React from 'react';
import './Settings.css';
import LContain from '../../layout/Contain/Contain';
import Button from '../../components/Button/Button';
import Checkbox from '../../components/Checkbox/Checkbox';

import {
  inject,
  observer
} from 'mobx-react';

import { setBackground } from '../../utils/style.js';

class Settings extends React.Component {
  render() {
    return (
      <LContain size='sm'>
        <div className='settings mt-4'>
          <div className='settings__top'>
            <h1 className='settings__title'>Settings</h1>
            <Button type='outline' textColor='white' size='sm' onClick={this.reloadApp}>Reload App</Button>
          </div>
          <div className='settings__row mt-4'>
            <Checkbox
              id='settings_sleep_mode'
              checked={this.props.settingsStore.sleepMode}
              onChange={() => {
                this.props.settingsStore.toggleSleepMode();
              }}
            />
            <label htmlFor='settings_sleep_mode' className='settings__row-label'>Sleep Mode</label>
          </div>
        </div>
      </LContain>
    );
  }

  componentWillMount() {
    setBackground('gray');
  }

  reloadApp() {
    window.location.reload(true);
  }
};

export default inject('settingsStore')(observer(Settings));



// WEBPACK FOOTER //
// ./src/views/Settings/index.js